import React, { useContext, useState } from "react";
import { useModal } from "react-modal-hook";
import { AuthContext } from "../../Authorization/AuthContext";
import Modal from "../../Common/Modal";
import { CreatePublicUserAccountModal } from "./PublicUserCreateAccountModal";
import { PublicUserLoginModalContent } from "./PublicUserLoginModal";

export enum PUBLIC_USER_AUTH_MODALS {
  SIGN_IN = "signIn",
  CREATE_ACCOUNT = "createAccount",
}

const ModalContent = ({ hideModal }: { hideModal: () => void }) => {
  const [modalContent, setModalContent] = useState<PUBLIC_USER_AUTH_MODALS>(
    PUBLIC_USER_AUTH_MODALS.SIGN_IN
  );

  switch (modalContent) {
    case PUBLIC_USER_AUTH_MODALS.SIGN_IN:
      return (
        <PublicUserLoginModalContent
          setActiveModal={setModalContent}
          hideModal={hideModal}
        />
      );
    case PUBLIC_USER_AUTH_MODALS.CREATE_ACCOUNT:
      return <CreatePublicUserAccountModal setActiveModal={setModalContent} />;
  }
};

export const usePublicUserAuthModal = () => {
  const authContext = useContext(AuthContext);
  const [showModal, hideModal] = useModal(
    () => (
      <Modal onRequestClose={hideModal}>
        <AuthContext.Provider value={authContext}>
          <ModalContent hideModal={hideModal} />
        </AuthContext.Provider>
      </Modal>
    ),
    []
  );

  return [showModal, hideModal] as const;
};
